import { Model } from "spraypaint"

import ApplicationRecord from "./applicationRecord/applicationRecord"

@Model()
export default class ReportingData extends ApplicationRecord {
  public static readonly jsonapiType = "reporting_datas"
}
